import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import { Levels } from '../App';
import { useAuth } from '../contexts/AuthContext';
import { getCurrentUser } from '../services/auth-service';

interface Props {
    availableSemids: string[];
    levels: Levels
}

const SemidDisplay = (props: Props) => {

    const { user } = useAuth()
    
    let sidString = ""
    // const user_ = getCurrentUser()
    const semids_ = user?.semidpairs ? user?.semidpairs : []; 
    // const semids_ = Object([0]); 
    semids_.forEach((semid: any) => {
        sidString += `<li>${semid}</li>`
    })
    sidString = sidString.slice(0, -2)

    let levString=""
    if(props.levels.lev0) levString+='lev0, '
    if(props.levels.lev1) levString+='lev1, '
    if(props.levels.lev2) levString+='lev2, '
    levString = levString.slice(0, -2)
    if(!props.levels.lev0 && !props.levels.lev1 && !props.levels.lev2) levString = "None"

    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }} className="semid_display">
            <nav aria-label="recieving-semid-description">
                <h3 style={{paddingBottom: 0, marginBottom: 0, paddingTop: '0.5em'}}>Receiving files from SEMIDs: </h3>
                <div>
                    <ul dangerouslySetInnerHTML={{__html: sidString}}>
                    </ul>
                </div>
                <h3 className="no-print">Downloading files from level: {levString}</h3>
            </nav>
        </Box>
    );
}

export default SemidDisplay
